<template>
  <div :class="computedClass">
    <input
      v-model="modelValue"
      type="checkbox"
      class="jade-checkbox__input"
      :id="indentifier"
      :name="name"
      :disabled="disabled"
      :indeterminate="indeterminate"
      :aria-invalid="error"
      :aria-disabled="disabled || readOnly"
      :aria-checked="isIndeterminate(modelValue) ? 'mixed' : modelValue"
      :defaultChecked="isIndeterminate(defaultChecked) ? false : defaultChecked"
      v-on="$listeners"
    />
    <label :for="indentifier">
      <div :class="computedClassBox">
        <JadeIcon
          v-if="indeterminate"
          use="minus"
          size="small"
        />
        <JadeIcon
          v-else
          use="check"
          size="small"
        />
      </div>
      <span
        v-if="label"
        class="jade-checkbox__label"
      >
        <JadeText
          color="current-color"
          variant="text-medium"
          weight="regular"
        >
          {{ label }}
        </JadeText>
      </span>
      <span
        v-if="supportText"
        class="jade-checkbox__support"
      >
        <JadeText
          color="current-color"
          variant="text-small"
          weight="regular"
        >
          {{ supportText }}
        </JadeText>
      </span>
    </label>
  </div>
</template>

<script>
import JadeText from '../JadeText'
import JadeIcon from '../JadeIcon'

export default {
  name: 'JadeCheckbox',
  components: {
    JadeText,
    JadeIcon
  },
  props: {
    name: String,
    id: String,
    label: String,
    supportText: String,
    value: Boolean,
    defaultChecked: Boolean,
    disabled: Boolean,
    readOnly: Boolean,
    indeterminate: {
      type: [Boolean, String]
    },
    disabledFocus: Boolean,
    error: Boolean
  },
  computed: {
    indentifier () {
      return this.id ?? this.name
    },
    computedClass () {
      return {
        'jade-checkbox': true,
        'is-error': this.error
      }
    },
    computedClassBox () {
      return {
        'jade-checkbox__box': true,
        'is-indeterminate': this.indeterminate,
        'is-focus-disabled': this.disabledFocus
      }
    },
    modelValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('update:value', value)
      }
    }
  },
  methods: {
    isIndeterminate (value = this.value) {
      return value === 'indeterminate'
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/checkbox.css';
</style>
